import { giphyBlack, giphyLightGrey } from '@giphy/colors'
import { SearchContext } from '@giphy/react-components'
import { setGADataLayer } from 'analytics'
import { useRouter } from 'next/navigation'
import { useContext } from 'react'
import styled, { css } from 'styled-components'
import { desktop } from 'ui/src/css'
import { CY_SEARCH_BAR__SUGGESTED_TERMS } from 'ui/src/utils/cy-test'
import { useSearchTags } from '../../../api/hooks'
import DropdownPingback from './dropdown-pingback'
import SearchIcon_ from './icons/search'

const NonHighlight = styled.span`
    color: ${giphyLightGrey};
`

const Word = styled.span`
    ${desktop(css`
        color: ${giphyBlack};
    `)}
`

const SearchIcon = styled(SearchIcon_)`
    ${desktop(css`
        display: none;
    `)}
`

const getMatch = (term: string, item: string) => {
    if (item.indexOf(term) === 0) {
        return (
            <>
                <Word>{term}</Word>
                <NonHighlight>{item.slice(term.length)}</NonHighlight>
            </>
        )
    } else {
        return <NonHighlight>item</NonHighlight>
    }
}

const Item = styled.div`
    display: flex;
    padding: 10px;
    font-style: italic;
    font-weight: 600;
    align-items: center;
    gap: 10px;
    cursor: pointer;
`

const SearchTags = () => {
    const { term } = useContext(SearchContext)
    const { data } = useSearchTags(term, { limit: 3 })
    const router = useRouter()
    return data?.data ? (
        <>
            {data.data.map(({ name, analytics_response_payload }) => (
                <DropdownPingback
                    key={name}
                    arp={analytics_response_payload}
                    responseId={data.meta.response_id}
                    eventType="DROPDOWN_AUTOCOMPLETE"
                    onClick={() => {
                        setGADataLayer({
                            event: 'search',
                            options: {
                                searchType: 'partial_search_suggestion',
                                searchTerm: name,
                            },
                        })
                        router.push(`/search/${encodeURIComponent(name)}`)
                    }}
                >
                    <Item className={CY_SEARCH_BAR__SUGGESTED_TERMS}>
                        <SearchIcon />
                        <div>{getMatch(term, name)}</div>
                    </Item>
                </DropdownPingback>
            ))}
        </>
    ) : null
}
export default SearchTags
